import React from 'react'
import { get } from 'lodash'
import popup from '../../popup'
import './style.css'
import axios from 'axios'
import {PHONE_FROM_COUNTRY} from '../../countryConstants'
import getCountryCode from '~/tools/userEnvironment/getCountryCode'

class UpdateNumber extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.metaDataMap=this.props.args.metaDataMap;
  }

  getVal(key){
    return get(this.metaDataMap, key)
  }

  componentDidMount(){
    this.checkForPhoneCode();
  }
    
  checkForPhoneCode=()=>{
    return getCountryCode().then( countryCode => {
      if(this.phoneInputCode)
        this.phoneInputCode.value="+"+PHONE_FROM_COUNTRY[`${countryCode}`]
    })
  }


  render() {
    if (this.state.forgotPasswordSuccess)
      return (this.successScreen())

    return (
      <div className="auth-view centered">
        <img className="mobile-logo-image" src={ get(window.settings, 'images.desktopLogo') } alt="logo"/>
        <div className="intro"> {this.getVal('UPDATE_PHONE_NUMBER')}</div>
        <form
          className="login-view"
          onSubmit={ evt => {
            evt.preventDefault()
            this.submitSendOTP()
          }}>
            <div className="phone-input-box">
                <input 
                    placeholder="+91"
                    ref={ i => { this.phoneInputCode = i} }  
                    autoFocus  
                    required
                />
                <input  
                    type="number"
                    placeholder={this.getVal('phoneInput') || "Please Enter Phone Number"}
                    ref={ i => { this.phoneInputNumber = i} }   
                    autoFocus 
                    required         
                />
            </div>
            <div className="error-box">{ this.state.error || '' }</div>
            <input
                type="submit"
                value={this.getVal('SEND_OTP_CTA_TEXT')}
                className="login-button button fat cta">
            </input>
        </form>
      
      </div>
    )
  }

  submitSendOTP = async() => {
    let user={};
    user["requestType"]="send";
    user["phoneNumber"]=this.phoneInputCode.value+this.phoneInputNumber.value;
    this.setState({...this.state, buttonProgress: true})
    const userInfo = JSON.parse(localStorage.getItem('user'));
    
    var signParams = {
      site: window.settings.internalName,
      userId: userInfo && userInfo.user && userInfo.user.userId 
    }
    await axios({
      method: 'POST',
      url: `${window.settings.apiBaseUrl}/identity/user/updatePhone`,
      params: signParams,
      data: user,
      headers: {
        'x-api-key': window.settings.baseAPIKey
      }
    }).then( res => {
      user["screenName"]="update"
      popup.verifyOTPScreen(user, this.metaDataMap);
      this.setState({...this.state, buttonProgress: false })
    }).catch(error=>{
        this.setState({...this.state, buttonProgress: false })
      var message =
        this.getVal((((error || {}).response || {}).data || {}).code) || this.getVal('defaultError')
      this.alert(message)
      if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
    })
  }

  alert = (message)=>{
    this.setState({...this.state, error: message })
  }
}

export default UpdateNumber;